"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomInput = void 0;
const react_1 = __importDefault(require("react"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const helpers_1 = require("../helpers");
const useLabelTooltip_1 = require("../../useLabelTooltip");
const CustomInput = (field) => {
    var _a, _b, _c, _d, _e;
    const hasErrors = Boolean((_a = field.rawErrors) === null || _a === void 0 ? void 0 : _a.length);
    const isNumber = field.schema.type === 'number' || field.schema.type === 'integer';
    const type = isNumber ? 'number' : 'text';
    const uiOptions = (_c = (_b = field.uiSchema) === null || _b === void 0 ? void 0 : _b['ui:options']) !== null && _c !== void 0 ? _c : {};
    const labelTooltip = (0, useLabelTooltip_1.useLabelTooltip)(uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.labelTooltip);
    return (react_1.default.createElement(wl_ui_kit_1.TextInput, Object.assign({}, uiOptions, { labelTooltip: labelTooltip, id: field.id, label: (0, helpers_1.getLabel)(field), name: field.id, onChange: (event) => {
            field.onChange(event.target.value || undefined);
        }, value: (_d = field.value) !== null && _d !== void 0 ? _d : '', hintType: hasErrors ? 'error' : undefined, required: Boolean(field.schema.required), placeholder: field.placeholder, hint: hasErrors ? (_e = field === null || field === void 0 ? void 0 : field.rawErrors) === null || _e === void 0 ? void 0 : _e[0] : '', disabled: field.disabled, type: type, 
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: field.autofocus })));
};
exports.CustomInput = CustomInput;
//# sourceMappingURL=custom-input.js.map